export default __webpack_public_path__ + "static/media/bollmann.5589e913.png";